// extracted by mini-css-extract-plugin
export default {"container":"promotionDetails_container__Est8l","profileName":"promotionDetails_profileName__gWeN6","username":"promotionDetails_username__yRu5M"};